import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df38e7b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog modal-md" }
const _hoisted_3 = { class: "modal-content overflow-hidden" }
const _hoisted_4 = { class: "modal-header py-3 px-4 gap-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "40",
    height: "40",
    rx: "10",
    fill: "#E8E8E8"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M29.0853 15.4197C28.8672 14.5985 28.2246 13.9518 27.4088 13.7323C25.9299 13.3335 20 13.3335 20 13.3335C20 13.3335 14.0702 13.3335 12.5913 13.7323C11.7755 13.9518 11.1329 14.5985 10.9148 15.4197C10.5186 16.9081 10.5186 20.0136 10.5186 20.0136C10.5186 20.0136 10.5186 23.1191 10.9148 24.6076C11.1329 25.4287 11.7755 26.0485 12.5913 26.268C14.0702 26.6668 20 26.6668 20 26.6668C20 26.6668 25.9299 26.6668 27.4088 26.268C28.2246 26.0485 28.8672 25.4287 29.0853 24.6076C29.4815 23.1191 29.4815 20.0136 29.4815 20.0136C29.4815 20.0136 29.4815 16.9081 29.0853 15.4197ZM18.0606 22.8332V17.1941L23.0169 20.0137L18.0606 22.8332Z",
    fill: "#203972"
  })
], -1))
const _hoisted_6 = {
  class: "modal-title",
  id: "modal-youtube-url-label",
  style: {"color":"var(--cor_texto_1)","margin-right":"auto"}
}
const _hoisted_7 = {
  ref: "btnCloseRef",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  style: {"background-color":"transparent","border":"none"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.6641 9L17.5503 4.11377C18.1499 3.51416 18.1499 2.54199 17.5503 1.94189L16.4644 0.855957C15.8647 0.256348 14.8926 0.256348 14.2925 0.855957L9.40625 5.74219L4.52002 0.855957C3.92041 0.256348 2.94824 0.256348 2.34814 0.855957L1.26221 1.94189C0.662598 2.5415 0.662598 3.51367 1.26221 4.11377L6.14844 9L1.26221 13.8862C0.662598 14.4858 0.662598 15.458 1.26221 16.0581L2.34814 17.144C2.94775 17.7437 3.92041 17.7437 4.52002 17.144L9.40625 12.2578L14.2925 17.144C14.8921 17.7437 15.8647 17.7437 16.4644 17.144L17.5503 16.0581C18.1499 15.4585 18.1499 14.4863 17.5503 13.8862L12.6641 9Z",
    fill: "#B5B5C3"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  class: "modal-body p-4",
  style: {"background-color":"var(--cor_background_2)"}
}
const _hoisted_11 = ["name", "id"]
const _hoisted_12 = { class: "col-12 p-0 d-flex justify-content-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: `modal-youtube-url-${_ctx.UUID}`,
    tabindex: "-1",
    "aria-labelledby": `modal-youtube-url-${_ctx.UUID}`,
    "aria-hidden": "true",
    "data-bs-backdrop": "static",
    "data-bs-keyboard": "false"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.header), 1),
          _createElementVNode("button", _hoisted_7, _hoisted_9, 512)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            ref: "inputRef",
            class: "form-control p-2",
            placeholder: "https://www.youtube.com/",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.youtubeURL) = $event)),
            type: "text",
            name: `modal-youtube-url-${_ctx.UUID}-input`,
            id: `modal-youtube-url-${_ctx.UUID}-input`
          }, null, 8, _hoisted_11), [
            [_vModelText, _ctx.youtubeURL]
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleYoutubeURL && _ctx.handleYoutubeURL(...args))),
              type: "submit",
              class: "btn btn-sm background_btn_1",
              style: {"color":"var(--cor_icones_1)"},
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, " Confirmar ")
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}